export default __webpack_public_path__ + "static/media/3003.8c0c8d93.jpg";